var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPickupEnabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icon-pickup-enabled"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-pickup-enabled",
    clipPath: "url(#clip-Icon-pickup-enabled)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5294",
    "data-name": "Group 5294",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5293",
    "data-name": "Group 5293",
    transform: "translate(5.5 4.781)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_570",
    "data-name": "Line 570",
    x1: 4,
    y2: 4,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_571",
    "data-name": "Line 571",
    x1: 4,
    y1: 4,
    transform: "translate(0 4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_572",
    "data-name": "Line 572",
    x1: 6.45,
    transform: "translate(0.55 4)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPickupEnabled);
export default __webpack_public_path__ + "static/media/Icon-pickup-enabled.69fc09a64dfa6ffbd50e4e39aaa46c4c.svg";
export { ForwardRef as ReactComponent };